/* OGX Cart ETA v2 — resilient to drawer re-renders */
(function () {
  function init(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const cutoffStr = root.dataset.cutoff || '16:00';
    const saturdayWorking = String(root.dataset.saturdayWorking) === 'true';
    const showCountdown = String(root.dataset.showCountdown) === 'true';

    const dayEl = root.querySelector('[data-eta-day]');
    const cdEl  = root.querySelector('[data-eta-countdown]');
    if (!dayEl) return;

    function nextWorkingDay(date, addDays) {
      const d = new Date(date);
      d.setDate(d.getDate() + addDays);
      // Sunday bump to Monday
      if (d.getDay() === 0) d.setDate(d.getDate() + 1);
      return d;
    }

    function labelForDay(d) {
      const now = new Date();
      const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      const tomorrow = new Date(now); tomorrow.setDate(now.getDate() + 1);

      if (d.toDateString() === now.toDateString()) return 'Today';
      if (d.toDateString() === tomorrow.toDateString()) return 'Tomorrow';
      return days[d.getDay()];
    }

    function compute(now) {
      const [hh, mm] = cutoffStr.split(':').map(Number);
      const cutoff = new Date(now);
      cutoff.setHours(Number.isFinite(hh) ? hh : 16, Number.isFinite(mm) ? mm : 0, 0, 0);

      let receive;
      if (now < cutoff) {
        // before cutoff → next working day
        receive = nextWorkingDay(now, 1);
      } else {
        // after cutoff → +2 by default (handles Sunday bump)
        receive = nextWorkingDay(now, 2);

        // Special-case: Friday after cutoff and Saturday counts as working → receive Saturday
        if (saturdayWorking && now.getDay() === 5) {
          receive = nextWorkingDay(now, 1);
        }
      }
      return { cutoff, receive };
    }

    function render() {
      const now = new Date();
      const { cutoff, receive } = compute(now);

      dayEl.textContent = labelForDay(receive);

      if (cdEl) {
        if (showCountdown) {
          let diff = cutoff - now;
          if (diff < 0) diff = 0;
          const h = Math.floor(diff / 36e5);
          const m = Math.floor((diff % 36e5) / 6e4);
          cdEl.textContent = ` (order in ${h}h ${m}m)`;
          cdEl.style.display = '';
        } else {
          cdEl.textContent = '';
          cdEl.style.display = 'none';
        }
      }
    }

    render();
    root._ogxEtaTimer && clearInterval(root._ogxEtaTimer);
    root._ogxEtaTimer = setInterval(render, 30000);
  }

  function scan() {
    document.querySelectorAll('.ogx-cart-eta').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Re-scan when the drawer content updates
  const mo = new MutationObserver(scan);
  mo.observe(document.body, { childList: true, subtree: true });
})();
